<template>
  <div :class="{
    'table-responsive': responsive,
  }">
    <table ref="table" class="table table-bordered" :class="{
      'table-layout-fixed': layoutFixed,
      'table-sm': small
    }">
      <thead class="table-secondary">
      <tr>
        <th
            v-for="column in columns"
            :key="column.key"
            :class="column.headClass || ''"
            :data-min-width="column.minWidth || 'false'"
            v-if="typeof column.condition == 'undefined' || (column.condition && column.condition(additionalData))"
        >
          <slot :name="`head_${column.key}`" :column="column">{{ column.label }}</slot>
        </th>
      </tr>
      </thead>
      <tbody>
      <slot name="rows" :body="body" :columns="columns">
        <tr v-for="row in body" :key="row[tid]">
          <td v-for="column in columns" :key="row[tid] + '_' + column.key" :class="column.bodyClass || ''">
            <slot :name="column.key" :row="row" :column="row[column.key]">{{ row[column.key] }}</slot>
          </td>
        </tr>
      </slot>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: "MyTable",
  props: {
    columns: Array,
    body: Array,
    tid: {
      type: String,
      required: true
    },
    small: {
      type: Boolean,
      default: true
    },
    responsive: {
      type: Boolean,
      default: false
    },
    layoutFixed: {
      type: Boolean,
      default: false
    },
    additionalData: null
  },
  data() {
    return {}
  },
  mounted() {
    const vm = this;

    vm.$nextTick(() => {
      let ths = vm.$refs.table.querySelectorAll('thead tr th:not([data-min-width=false])');
      let resizer = new ResizeObserver(entries => {
        entries.forEach(entry => {
          let width = entry.borderBoxSize[0]?.inlineSize || entry.borderBoxSize.inlineSize;
          if (entry.target.dataset.minWidth < width) {
            entry.target.style.width = 'auto';
          } else {
            entry.target.style.width = entry.target.dataset.minWidth + 'px';
          }
        })
      })

      ths.forEach(th => {
        resizer.observe(th);
      })

    });
  }
}
</script>
